import EfScrollAni from '@/efscrollani';
import Detail from './detail';
import styles from './index.module.scss';

export default function Delta3PortablePowerStation() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className={styles.page}>
            <Detail />
        </div>
    );
}
